import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ScienceLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_13_"
        x1="776.171"
        x2="843.975"
        y1="182.388"
        y2="182.388"
        gradientTransform="rotate(-25.604 810.161 185.217)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_13_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M835.6 205.1l-31.3 12.2c-7.1 2.8-15.2-.8-18-7.9l-12-31c-2.8-7.1.8-15.2 7.9-18l31.3-12.2c7.1-2.8 15.2.8 18 7.9l12 31c2.8 7.2-.8 15.2-7.9 18z"
      />
      <image
        width="48"
        height="48"
        x="785.5"
        y="159.5"
        transform="rotate(-21.2 810.5 184.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_12_"
        x1="841.806"
        x2="913.779"
        y1="143.369"
        y2="143.369"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_12_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M901.3 168.5l-31.6 8.3c-7.5 2-15.2-2.5-17.2-10l-8.2-31.3c-2-7.5 2.5-15.2 10-17.2l31.6-8.3c7.5-2 15.2 2.5 17.2 10l8.2 31.3c2 7.5-2.5 15.2-10 17.2z"
      />
      <image
        width="48"
        height="48"
        x="854"
        y="119.5"
        transform="rotate(-14.68 878 143.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_11_"
        x1="915.016"
        x2="976.62"
        y1="122.606"
        y2="122.606"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_11_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M961.7 151.3l-32.4-.4c-6.9-.1-12.3-5.7-12.3-12.6l.4-32.1c.1-6.9 5.7-12.3 12.6-12.3l32.4.4c6.9.1 12.3 5.7 12.3 12.6l-.4 32.1c-.2 6.9-5.8 12.3-12.6 12.3z"
      />
      <image
        width="48"
        height="48"
        x="922"
        y="98"
        transform="rotate(0.71 902 122)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <circle cx="854.3" cy="206.5" r="1.8" fill="#DCEC43" />
      <linearGradient
        id="SVGID_9_"
        x1="831.729"
        x2="903.724"
        y1="236.319"
        y2="236.319"
        gradientTransform="rotate(-4.156 865.785 230.012) scale(1.00003)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_9_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M890.8 265.9l-36.2 5.1c-7.9 1.1-15.3-4.4-16.4-12.4l-5.1-35.9c-1.1-7.9 4.4-15.3 12.4-16.4l36.2-5.1c7.9-1.1 15.3 4.4 16.4 12.4l5.1 35.9c1.1 8-4.4 15.3-12.4 16.4z"
      />
      <image
        width="48"
        height="48"
        x="844.3"
        y="212.6"
        transform="rotate(-8.02 868.3 236.6)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_10_"
        x1="902.864"
        x2="975.387"
        y1="198.965"
        y2="198.965"
        gradientTransform="rotate(-24.03 941.464 202.186)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <path
        fill="#FFF"
        stroke="url(#SVGID_10_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M960.5 227.5l-31.7 7.1c-8 1.8-16-3.4-17.8-11.6l-6.9-32c-1.8-8.2 3.3-16.3 11.4-18.1l31.7-7.1c8-1.8 16 3.4 17.8 11.6l6.9 32c1.7 8.2-3.4 16.3-11.4 18.1z"
      />
      <image
        width="48"
        height="48"
        x="914"
        y="176"
        transform="rotate(-12.5 938 200)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_14_"
        x1="972.811"
        x2="1035.764"
        y1="161.261"
        y2="161.261"
        gradientTransform="rotate(17.855 1006.45 166.997)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <path
        data-size={63}
        fill="#FFF"
        stroke="url(#SVGID_14_)"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1012.6 194.7l-31.5-10.8c-6.7-2.3-10.3-9.7-8-16.5l10.5-32c2.2-6.8 9.5-10.5 16.1-8.2l31.5 10.8c6.7 2.3 10.3 9.7 8 16.5l-10.5 32c-2.2 6.8-9.4 10.5-16.1 8.2z"
      />
      <image
        width="48"
        height="48"
        x="982"
        y="137"
        transform="rotate(19.18 1006 161)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g id="group-5" transform="translate(-5, -33)">
      <g id="element-5">
        <g id="component-item-5">
          <g id="Science">
            <ellipse
              cx="926.1"
              cy="238.4"
              fill="#55A32A"
              opacity="0.5"
              rx="80.4"
              ry="151.9"
              transform="matrix(.05357 -.9986 .9986 .05357 638.431 1150.415)"
            />
            <path
              fill="#893E29"
              d="M740.1 255.7L766 317s2.8 1.4 8 3.3c2.8-4.3 9.1-10.4 16.7-8.8 25.5 5.3 69.3 21.1 120.7-3 85-39.7 114-108.1 114-108.1l2-37.2-44.4-30.3s-54.5-14.6-139.4 25.2-79.3 82.6-79.3 82.6l-24.2 15z"
            />
            <path
              fill="#6C2A29"
              d="M972.9 139.8l-5.5 28.4 30.2 31.2 22.8-29.3s-3.9-3.8-9.8-8.8c-.4-.4-4 11.9-4 11.9s1.6-13.9 1-14.3c-4.4-3.5-9.5-7.3-14.9-10.6-.6-.4-3.1 5.7-3.1 5.7s-.1-7.6-.8-8c-5.3-3-10.8-5.3-15.9-6.2z"
            />
            <path
              fill="#974429"
              d="M771.4 238.1l18.3 20.6s88.4-72.9 177.7-90.5c3.8-13.8 5.5-28.4 5.5-28.4s-40.7-8.2-100.2 17.5c-106.4 45.9-101.3 80.8-101.3 80.8z"
            />
            <path
              fill="#703229"
              d="M967.4 168.2s-45.2 3.1-91.5 22.1-88.1 66.7-88.1 66.7l9 12.3s41.7 7.5 92.7 1.6S998 198.3 998 198.3l-30.6-30.1z"
            />
            <path
              fill="#C08330"
              d="M947.8 141.5l-31.3 9.8 76 53.1s15.4-15.2 18.2-20.8c-55.5-39.8-62.9-42.1-62.9-42.1z"
            />
            <path
              fill="#703229"
              d="M754.3 269.1L773.9 320.6 790.7 311.5 781.3 255.8 763.7 250.9z"
            />
            <path
              fill="#C08330"
              d="M764.2 240.6L740.1 255.7 754.3 269.1 766.6 262.9 762.9 253.9 770.7 259.4 781.3 255.8z"
            />
            <path
              fill="#5A2434"
              d="M916.6 151.3L916.3 156.9 988.7 208.1 992.6 204.4z"
            />
            <path
              fill="#703229"
              d="M1026.8 174.4s-30 38.4-39.9 49.3c-9.9 10.9-33.7 27.6-33.7 27.6l1.2 14.2-5.6-11.7s-8.4 11.7-27.8 20.5-52.7 14.1-64.2 12.6c-11.6-1.4-42.3-5.8-42.3-5.8l1 10.3-4.4-12s-6 3.6-11 2.2-13.6-7-13.6-7 5.1 35.2 7.7 36.9c14.3 7.4 55.6 18.3 94.6 6.6s68.6-35.6 80.7-45.5 42.7-51.1 48.9-59c6.2-7.9 6.9-13.2 6.9-13.2l1.5-26z"
            />
            <path fill="#893E29" d="M767.6 267.3L774.6 301.8 766.3 277.8z" />
            <path fill="#893E29" d="M816.2 295.5L816 310.5 820.3 317.8z" />
            <path fill="#893E29" d="M845.3 285.3L854.6 317.6 850.6 284.1z" />
            <path fill="#893E29" d="M938.4 262.3L945.6 285.4 942.4 257.3z" />
            <path fill="#893E29" d="M1024.1 173.5L1022.3 194.1 1018.9 181.3z" />
            <path fill="#893E29" d="M837.6 173L837.4 198.9 827.9 175.2z" />
            <path fill="#893E29" d="M898.5 143L902.3 158.8 904.2 141z" />
            <path fill="#893E29" d="M779 214.9L785.1 236.2 775.9 218.9z" />
            <path fill="#893E29" d="M786.6 225.1L799.7 245.2 805.3 239.6z" />
            <path
              fill="#C08330"
              d="M812.2 197c-10.8 0-26.6 23.4-26.6 23.4l59.3 52s34.8 3.9 52.7-2.6c-6.1-11.2-68.9-61-85.4-72.8z"
            />
            <path
              fill="#5A2434"
              d="M785.6 220.4l1 4.7 53.2 47.9 5.1-.5c0-.1-54-50.6-59.3-52.1z"
            />
            <path
              fill="#893E29"
              d="M847.1 182.5l4.9 20.1s10.8-5.8 14.1-7.7c-12.4-7.2-19-12.4-19-12.4z"
            />
            <path
              fill="#C08330"
              d="M878.8 159l-32.2 17.6 90.9 74.8s21.5-14.1 28.5-21.3c-17.3-16.9-87.2-71.1-87.2-71.1z"
            />
            <path
              fill="#5A2434"
              d="M846.6 176.6L847.1 182.5 933.6 254 937.5 251.4z"
            />
            <path
              fill="#893E29"
              d="M916.3 156.9s4.6 19.7 5 19.3c6.2-1.7 17.1-3.8 17.1-3.8l-22.1-15.5z"
            />
            <path fill="#893E29" d="M853.9 172.7L888.1 197.5 858.2 169.7z" />
            <path fill="#893E29" d="M800.5 202.3L810.3 208 804.5 199.2z" />
            <path
              fill="#893E29"
              d="M790.4 214.2l29.1 20.4-26.4-24.4s-3.1 3.2-2.7 4z"
            />
            <g fill="#FFF" transform="translate(100, -50)">
              <path d="M826.1 340.4c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.3v-.4-.4-.8c0-.3.1-.5.1-.8 0-.1.1-.3.2-.3.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.1.2 0 .4.1.7.1h1c.4 0 .8 0 1.2-.1.4 0 .7-.1 1-.2.3-.1.5-.2.7-.4.2-.2.3-.4.3-.6 0-.2-.2-.3-.6-.4-.4-.1-.9-.2-1.4-.3s-1.2-.2-1.9-.4-1.3-.4-1.9-.7-1.1-.7-1.4-1.2c-.4-.5-.6-1.1-.6-1.9 0-.8.2-1.5.6-2.1s1-1.1 1.7-1.5c.7-.4 1.5-.7 2.4-.8.9-.2 1.8-.3 2.7-.3h.7c.2 0 .5 0 .7.1l.1-.5c0-.1.1-.2.2-.3.1-.1.2-.2.4-.2.8 0 1.4.1 2.1.3.2.1.4.2.4.3.1.1.1.3.1.4 0 .5-.1.9-.1 1.3s-.1.8-.1 1.1c0 .3-.1.7-.1 1-.1.3-.1.6-.2 1 0 .2-.1.3-.2.4-.1.1-.3.2-.5.2h-1c-.3 0-.6-.1-.9-.2-.1 0-.3-.1-.3-.3s-.1-.3-.1-.4v-.5-.5c-.3 0-.5-.1-.8-.1h-.7c-.4 0-.8 0-1.2.1-.4.1-.7.1-.9.2-.3.1-.5.2-.6.4-.2.1-.2.3-.2.5 0 .3.2.5.5.6.4.1.8.2 1.4.3.5.1 1.1.2 1.8.4.6.2 1.2.4 1.8.7.5.3 1 .7 1.4 1.2.4.5.5 1.2.5 2s-.2 1.4-.5 2c-.3.6-.8 1.1-1.4 1.5-.6.4-1.3.7-2.1.9-.8.2-1.7.3-2.7.3-.9.1-1.7 0-2.6-.2zM842.7 330.6c.3 0 .6 0 1 .1.3 0 .7.1 1 .3.3.1.5.3.7.4.1.2.2.4.3.8 0 .2 0 .4.1.6v.6c0 .5 0 .9-.1 1.4-.1.3-.1.5-.2.6-.1.1-.3.1-.6.1-.4 0-.8 0-1.1-.1-.5-.1-.8-.4-.9-.9 0-.2 0-.4-.1-.6v-.6c-.4 0-.7.1-1 .2-.3.1-.6.3-.8.5-.2.2-.4.4-.6.7-.1.3-.2.6-.2.9 0 .3.1.6.2.9.1.3.3.5.5.7.2.2.4.4.7.5.3.1.6.2 1 .2.2 0 .4 0 .6-.1s.4-.1.6-.2c.2-.1.4-.1.6-.2.2-.1.3-.1.4-.2.1-.1.3-.1.4-.2.1 0 .2-.1.3-.1.2 0 .3.1.5.4.1.1.2.3.2.5s.2.3.2.5c0 .1.1.2.1.3v.3c0 .2-.1.4-.3.6-.2.2-.4.3-.7.5s-.6.3-.9.4c-.3.1-.7.2-1 .2-.4.1-.7.1-1 .1-.8 0-1.6-.1-2.2-.3-.6-.2-1.1-.4-1.5-.7-.4-.3-.8-.6-1-1-.3-.4-.4-.7-.6-1.1-.1-.4-.2-.7-.3-1 0-.3-.1-.6-.1-.9 0-.7.2-1.4.5-2.1.3-.6.8-1.2 1.4-1.7.6-.5 1.2-.8 2-1.1.3-.1 1.1-.2 1.9-.2zM849.4 326c.4 0 .7 0 .9.1.3.1.5.2.6.3s.3.4.4.6c.1.3.1.6.1 1.1 0 .3 0 .5-.1.7l-.3.6c-.1.2-.4.3-.6.4-.3.1-.6.1-1 .1s-.7 0-.9-.1c-.3-.1-.5-.2-.6-.3-.2-.2-.3-.4-.3-.6-.1-.2-.1-.6-.1-.9 0-.6.2-1.1.4-1.4.3-.4.8-.6 1.5-.6zm-1.6 6.1c0-.3.1-.6.1-.8.1-.2.2-.3.5-.4.2-.1.5-.1.8-.1H850.6c.2 0 .3.1.4.2s.1.3.1.6v4c0 1.2-.1 2.5-.2 3.9 0 .2 0 .4-.1.5 0 .1-.1.3-.1.3-.1.1-.2.1-.3.2-.1 0-.3.1-.6.1-.4 0-.7 0-1.1-.1-.4 0-.7-.1-.8-.3-.1-.2-.2-.4-.2-.7 0-.5 0-1-.1-1.4v-1.4-2.3c.1-.8.1-1.5.2-2.3zM862.1 335.8c-.3.1-.7.2-1.2.3l-1.5.3c-.5.1-1.1.2-1.7.2-.6.1-1.1.1-1.7.1.3.3.6.5 1 .7.4.2.9.3 1.3.3.3 0 .8 0 1.2-.1.5-.1.9-.2 1.3-.4.2-.1.4-.1.4-.1.1 0 .2 0 .2.1.1.1.1.2.2.3.1.1.1.3.1.4s.1.3.1.4v.4c0 .3-.1.5-.3.7-.4.4-1 .7-1.7.9-.7.2-1.5.3-2.4.3-.7 0-1.3-.1-1.9-.4-.6-.2-1.1-.6-1.6-1s-.8-1-1.1-1.6c-.3-.6-.4-1.3-.4-2.1s.1-1.5.4-2.1c.3-.6.7-1.2 1.1-1.6.5-.5 1-.8 1.7-1.1.6-.3 1.3-.4 2-.4.9 0 1.7.2 2.3.5.6.3 1.1.7 1.5 1.2.4.5.7 1 .8 1.5.2.5.2 1 .2 1.3 0 .2 0 .3-.1.4.1.4 0 .6-.2.6zm-4.4-2.5c-.5 0-.9.1-1.3.4-.4.3-.7.6-.8 1.1.6 0 1.2-.1 1.9-.1.7-.1 1.3-.1 1.8-.3-.1-.4-.4-.7-.7-.8-.3-.2-.6-.3-.9-.3zM863.6 331.9c0-.3 0-.6.1-.8s.2-.3.5-.4c.2 0 .3-.1.6-.1.2 0 .4-.1.7-.1.2 0 .5 0 .7-.1h.6c.2 0 .3 0 .4.1.1.1.1.2.1.4v.5c.5-.3 1-.6 1.6-.8.6-.2 1.1-.3 1.7-.3.3 0 .6 0 .9.1.4.1.7.2 1 .4.3.2.6.5.8.9.2.4.3.9.3 1.5v1.3c0 .5 0 1-.1 1.5 0 .6-.1 1.1-.1 1.7-.1.6-.1 1.2-.2 1.8 0 .2-.1.4-.2.6-.1.2-.3.3-.7.3-.2 0-.5 0-.8-.1-.3 0-.6-.1-.9-.1-.4-.1-.6-.4-.6-.9v-.5c0-.2 0-.5.1-.9 0-.4.1-.8.1-1.4v-2.1c0-.3-.1-.6-.2-.8-.1-.2-.3-.3-.6-.3s-.7.1-1.1.2c-.4.1-.8.3-1.1.6 0 .9 0 1.7.1 2.6 0 .8.1 1.7.2 2.5v.4c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.7-.1-.8-.3-.1-.2-.2-.4-.2-.7-.1-1-.2-2-.3-3.1-.1-1-.1-2.1-.1-3.1v-.7c-.3 0-.3-.3-.3-.5zM880.5 330.6c.3 0 .6 0 1 .1.3 0 .7.1 1 .3.3.1.5.3.7.4.1.2.2.4.3.8 0 .2 0 .4.1.6v.6c0 .5 0 .9-.1 1.4-.1.3-.1.5-.2.6-.1.1-.3.1-.6.1-.4 0-.8 0-1.1-.1-.5-.1-.8-.4-.9-.9 0-.2 0-.4-.1-.6v-.6c-.4 0-.7.1-1 .2-.3.1-.6.3-.8.5-.2.2-.4.4-.6.7-.1.3-.2.6-.2.9 0 .3.1.6.2.9.1.3.3.5.5.7.2.2.4.4.7.5.3.1.6.2 1 .2.2 0 .4 0 .6-.1s.4-.1.6-.2c.2-.1.4-.1.6-.2.2-.1.3-.1.4-.2.1-.1.3-.1.4-.2.1 0 .2-.1.3-.1.2 0 .3.1.5.4.1.1.2.3.2.5s.2.3.2.5c0 .1.1.2.1.3v.3c0 .2-.1.4-.3.6-.2.2-.4.3-.7.5-.3.1-.6.3-.9.4-.3.1-.7.2-1 .2-.4.1-.7.1-1 .1-.8 0-1.6-.1-2.2-.3-.6-.2-1.1-.4-1.5-.7-.4-.3-.8-.6-1-1-.3-.4-.4-.7-.6-1.1-.1-.4-.2-.7-.3-1 0-.3-.1-.6-.1-.9 0-.7.2-1.4.5-2.1.3-.6.8-1.2 1.4-1.7.6-.5 1.2-.8 2-1.1.4-.1 1.1-.2 1.9-.2zM894.5 335.8c-.3.1-.7.2-1.2.3l-1.5.3c-.5.1-1.1.2-1.7.2-.6.1-1.1.1-1.7.1.3.3.6.5 1 .7.4.2.9.3 1.3.3.3 0 .8 0 1.2-.1.5-.1.9-.2 1.3-.4.2-.1.4-.1.4-.1.1 0 .2 0 .2.1.1.1.1.2.2.3.1.1.1.3.1.4s.1.3.1.4v.4c0 .3-.1.5-.3.7-.4.4-1 .7-1.7.9-.7.2-1.5.3-2.4.3-.7 0-1.3-.1-1.9-.4s-1.1-.6-1.6-1-.8-1-1.1-1.6c-.3-.6-.4-1.3-.4-2.1s.1-1.5.4-2.1c.3-.6.7-1.2 1.1-1.6.5-.5 1-.8 1.7-1.1.6-.3 1.3-.4 2-.4.9 0 1.7.2 2.3.5.6.3 1.1.7 1.5 1.2.4.5.7 1 .8 1.5.2.5.3 1 .3 1.3 0 .2 0 .3-.1.4 0 .4-.1.6-.3.6zm-4.4-2.5c-.5 0-.9.1-1.3.4-.4.3-.7.6-.8 1.1.6 0 1.2-.1 1.9-.1.7-.1 1.3-.1 1.8-.3-.1-.4-.4-.7-.7-.8-.2-.2-.6-.3-.9-.3z" />
            </g>
          </g>
          {resources && (
            <g className="resources-wrap" transform="translate(5, 20)">
              <ResourceLink
                r={resources[0]}
                svgComponent={resource1SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[0], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[1]}
                svgComponent={resource2SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[1], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[2]}
                svgComponent={resource3SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[2], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[3]}
                svgComponent={resource4SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[3], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[4]}
                svgComponent={resource5SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[4], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[5]}
                svgComponent={resource6SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[5], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
            </g>
          )}
        </g>
      </g>
    </g>
  );
};

export default ScienceLink;
